import React from "react";
import IconToolTip from "../../iconfont/topEdit/toolTip";
import {Tooltip} from "antd";

/**
 * text: 左侧文本
 * tip： 提示的文本
 * style： icon的样式对象
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const TableTip = (props) => {
    const {text, tip, style} = props

    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <span style={{marginRight: '3px'}}>{text || ''}</span>
            <Tooltip title={tip || ''}>
                <span style={{fontSize: '17px', ...style}}><IconToolTip/></span>
            </Tooltip>
        </div>
    )
}
export default TableTip